import api from "./axiosConfig";

function buildError(err) {
  const status = err?.response?.status;
  const data = err?.response?.data;
  const message =
    data?.message || data?.error || err.message || "Request failed";
  return { status, data, message, original: err };
}

export const getData = async (url, config = {}) => {
  try {
    const response = await api.get(url, { params: config?.params, ...config });
    return response.data;
  } catch (err) {
    throw buildError(err);
  }
};

export const postData = async (url, data, config = {}) => {
  try {
    const response = await api.post(url, data, config);
    return response.data;
  } catch (err) {
    throw buildError(err);
  }
};

export const putData = async (url, data, config = {}) => {
  try {
    const response = await api.put(url, data, config);
    return response.data;
  } catch (err) {
    throw buildError(err);
  }
};

export const deleteData = async (url, config = {}) => {
  try {
    const response = await api.delete(url, config);
    return response.data;
  } catch (err) {
    throw buildError(err);
  }
};
